import { render, staticRenderFns } from "./ProductsSearchList.vue?vue&type=template&id=263cbffc&"
import script from "./ProductsSearchList.vue?vue&type=script&lang=js&"
export * from "./ProductsSearchList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports